const features = [
  {
    icon: "ri-shield-flash-line",
    title: "Enterprise-Grade Security",
    description:
      "Every product is built with AES-256 encryption and strict zero-log policies, ensuring your data and identity remain fully protected at all times.",
  },
  {
    icon: "ri-speed-line",
    title: "Performance Optimized",
    description:
      "Engineered specifically for iOS, our apps are lightweight, battery-friendly, and deliver blazing-fast performance without draining your resources.",
  },
  {
    icon: "ri-user-heart-line",
    title: "Intuitive User Experience",
    description:
      "We obsess over usability. Our interfaces are clean, minimal, and designed for one-tap actions — so anyone can use them without a learning curve.",
  },
  {
    icon: "ri-lock-password-line",
    title: "Privacy by Design",
    description:
      "Privacy is not a feature — it is the foundation. We never collect, sell, or share user data. Your information stays yours, always.",
  },
  {
    icon: "ri-apple-line",
    title: "Native iOS Integration",
    description:
      "Deep integration with Apple&apos;s ecosystem means seamless support for Face ID, iCloud, Siri Shortcuts, and the latest iOS updates.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Dedicated Support",
    description:
      "Our expert team is always available to assist users and resolve issues quickly. We stand behind every product we ship.",
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="bg-[#0f0f0f] py-32">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-semibold tracking-[0.25em] uppercase text-[#00d4ff] mb-4">
            Why BADI D.O.O.
          </span>
          <h2 className="text-5xl font-bold text-white leading-tight">
            Built on Core Principles
          </h2>
          <p className="text-[#7a7a7a] text-lg mt-4 max-w-xl mx-auto">
            Everything we build is guided by a commitment to security, performance, and
            the best possible experience for iOS users.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group bg-[#1a1a1a] border border-[#272727] rounded-xl p-7 transition-all duration-300 hover:border-[#00d4ff]/30"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#00d4ff]/10 mb-5">
                <i className={`${feature.icon} text-2xl text-[#00d4ff]`}></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-3">{feature.title}</h3>
              <p className="text-[#7a7a7a] text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
